import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ISystemDetails } from "./system-details";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';

@Injectable()
export class SystemDetailsRetriever {
    constructor(private http: AdalHttp) {
    }

    getSystemDetailsByGuid(systemGuid: string): Observable<any> {
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/systemdetails/systems/" + systemGuid;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }
    getSystemDetailsBySystemTypeAndId(systemType: string, systemId: string): Observable<any> {
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/systemdetails/systemtypes/" + systemType + "/systems/" + systemId;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    getSystemDetailsBySystemTypeAndOwnershipCode(systemType: string, ownershipCode: string): Observable<any> {
        let productUrl: string = `/api/systemdetails/systemtypes/${systemType}/systems/ownershipcode/${ownershipCode}`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemDetailsRetriever/system-details-retriever.service.ts
 **/